import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import { Subject, takeUntil } from 'rxjs'
import { DishModel } from 'src/app/models/dish.model'
import { AyBService } from 'src/app/services/api/ayb.service'
@Component({
  selector: 'app-reporte-stock',
  templateUrl: './reporte-stock.component.html',
  styleUrls: ['./reporte-stock.component.scss']
})
export class ReporteStockComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()
  dishes: DishModel[] = []
  displayedColumns: string[] = [
    'id',
    'nombreInsumo', // Displayed as Nombre
    // 'categoria',
    // 'peso',
    'unidadMedida', // Displayed as Unidad de Medida
    //  'costo',
    'stock'
    //'modificar',
    //'eliminar'
  ]

  selectCategoria: string | null = null
  arrayCategorias: any = []
  dataSource = new MatTableDataSource()
  isLoading = true

  paginator!: MatPaginator
  @ViewChild(MatPaginator) set matPaginator (paginator: MatPaginator) {
    this.paginator = paginator
    if (this.paginator) {
      this.dataSource.paginator = paginator
    }
  }
  sort!: MatSort
  @ViewChild(MatSort, { static: false }) set matSort (matSort: MatSort) {
    this.sort = matSort
    if (this.sort) {
      this.dataSource.sort = matSort
    }
  }

  constructor (
    private readonly alimentosService: AyBService,
    private readonly router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit (): void {
    this.getAllInsumos()
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  getAllInsumos () {
    this.alimentosService
      .queryGetAllFoodItemsSku()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(response => {
        console.log(response)
        this.dishes = response.getAllFoodItemsSku?.insumos || []
        const categoria = this.dishes
          .filter(
            (item: any) => item.categoria !== '' && item.categoria !== null
          )
          .map((item: any) => item.categoria)
        this.arrayCategorias = [...new Set(categoria)]
        this.dataSource.data = this.dishes
        this.dataSource.paginator = this.paginator
        this.isLoading = false
      })
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  applyFilterSelect () {
    let dataNew: any = this.dishes
    if (this.selectCategoria) {
      dataNew = dataNew?.filter(
        (item: any) => item.categoria === this.selectCategoria
      )
    }

    this.dataSource.data = dataNew
  }
}
